import React from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import "../css/privacy.scss";

function Privacy() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="privacy">
      <Header />
      <div className="shopify-policy__container">
        <div className="shopify-policy__title">
          <h1>Privacy Policy</h1>
        </div>
        <div className="shopify-policy__body">
          <div className="rte prose max-w-none">
            <p><strong>Last updated: September 8, 2026</strong></p>
            <p>
              This Privacy Policy explains how Petoutlet collects, uses,
              discloses, retains, and protects personal data when you visit our
              website, contact us, or place an order. We handle personal data in
              accordance with applicable requirements, including Hong Kong's
              Personal Data (Privacy) Ordinance (Cap. 486).
            </p>

            <h2>1. Personal data we collect</h2>
            <p>Depending on how you use the website, we may collect:</p>
            <ul>
              <li>contact and delivery details, including name, email, telephone number, and postal address;</li>
              <li>order, return, customer-service, and transaction records;</li>
              <li>payment confirmation and limited payment-related details supplied by payment providers;</li>
              <li>device, browser, log, cookie, and website usage information; and</li>
              <li>communications, preferences, feedback, and information you choose to provide.</li>
            </ul>

            <h2>2. How we collect personal data</h2>
            <p>
              We collect data directly from you when you complete checkout,
              contact us, or interact with the website. We may also receive data
              automatically from your device and from service providers that
              support payments, delivery, security, analytics, or website operations.
            </p>

            <h2>3. Why we use personal data</h2>
            <ul>
              <li>to process, deliver, and support orders, returns, and refunds;</li>
              <li>to respond to questions and provide customer service;</li>
              <li>to operate, secure, troubleshoot, and improve the website;</li>
              <li>to prevent fraud, abuse, or unauthorized transactions;</li>
              <li>to meet accounting, regulatory, and legal obligations; and</li>
              <li>to send marketing only where you have requested it or where otherwise permitted.</li>
            </ul>

            <h2>4. Disclosure and service providers</h2>
            <p>
              We may disclose relevant data to providers supporting website
              hosting, payment processing, fraud prevention, order fulfillment,
              delivery, communications, analytics, and professional advice. We
              may also disclose data when required by law, to protect legal
              rights, or in connection with a business reorganization. We do not
              sell personal data.
            </p>

            <h2>5. Cookies and similar technologies</h2>
            <p>
              We may use cookies for core website functions, preferences,
              security, analytics, and—where enabled—marketing. Details and
              available controls are in our{" "}
              <Link to="/cookies" onClick={toTop}>Cookie Policy</Link>.
            </p>

            <h2>6. Retention and security</h2>
            <p>
              We retain personal data only for as long as reasonably necessary
              for the purposes described above, including legal, accounting,
              dispute-resolution, and security needs. We use reasonable
              administrative, technical, and physical safeguards, but no online
              service can guarantee absolute security.
            </p>

            <h2>7. International processing</h2>
            <p>
              Some service providers may process data outside Hong Kong. Where
              this occurs, we take reasonable steps to require protection
              consistent with applicable privacy obligations.
            </p>

            <h2>8. Your choices and requests</h2>
            <p>
              Subject to applicable law, you may request access to or correction
              of personal data we hold about you. You may also unsubscribe from
              marketing through the message instructions or by contacting us.
              We may need to verify your identity before completing a request.
            </p>

            <h2>9. Children's privacy</h2>
            <p>
              The website is intended for adults and is not directed to
              children. If you believe a child has provided personal data
              without appropriate authorization, please contact us.
            </p>

            <h2>10. Changes and contact</h2>
            <p>
              We may update this policy to reflect changes to our practices or
              legal obligations. The current version will be posted here with a
              revised date. For privacy questions, access or correction requests,
              email <a href="mailto:audit@petoutlet.work">audit@petoutlet.work</a>.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Privacy;
